import { useTranslation } from 'react-i18next'
import { create } from 'zustand'
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	// ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useMediaQuery,
} from '@chakra-ui/react'
import Swal from 'sweetalert2'
// import { PrimaryButton } from './Footer/styleComponent/PrimaryButton'

// const handleOpen = useLiteModal((state) => state.handleOpen)
export const useLiteModal = create<LiteModalStore>((set) => ({
	open: false,
	handleOpen: () => set({ open: true }),
	handleClose: () => set({ open: false }),
}))

export const useLiteModalAlert = () => {
	const { t } = useTranslation()

	const handleOpen = (reason: string) =>
		Swal.fire({
			title: t('liteModal.title'),
			text: t(`liteModal.text.${reason}`),
		})

	return handleOpen
}

type LiteModalStore = {
	open: boolean
	handleOpen: () => void
	handleClose: () => void
}

const LiteModal = () => {
	const open = useLiteModal((state) => state.open)
	const handleClose = useLiteModal((state) => state.handleClose)

	const [isPc] = useMediaQuery('(min-width: 1300px)')

	const { t } = useTranslation()

	return (
		<Modal
			isOpen={open}
			onClose={handleClose}
		>
			<ModalOverlay />
			<ModalContent
				maxW={'100%'}
				width={isPc ? '840px' : 'calc(100% - 20px)'}
			>
				<ModalHeader
					className='interval'
					display='flex'
					alignItems={'center'}
					justifyContent='center'
					textAlign={'center'}
					gap='30px'
					position={'relative'}
				>
					<Text color='#475154'>{t('liteModal.title')}</Text>
				</ModalHeader>
				<ModalCloseButton
					position={'absolute'}
					top={isPc ? '-40px' : '5px'}
					color={isPc ? 'white' : 'unset'}
					border={isPc ? '1px solid white' : '1px solid rgb(26,32,44)'}
					rounded={'100px'}
					left={isPc ? '0' : '25px'}
					right='unset'
				/>
				<ModalBody>
					<Text
						color='#475154'
						className='whitespace-break-spaces text-center'
					>
						{t('liteModal.text')}
					</Text>
				</ModalBody>
				{/* <ModalFooter width={'full'}>
					<PrimaryButton
						styles={{ minW: 'full' }}
						onClick={() => {
							onSubmit(phone)
							onClose()
						}}
					>
						{t('adminOnboarding.save')}
					</PrimaryButton>
				</ModalFooter> */}
			</ModalContent>
		</Modal>
	)
}

export default LiteModal
